'use client';

import type { ComponentProps } from 'react';
import { createDefaultWelcomeMessage as createDefaultWelcomeMessageImpl } from './chat-helpers';
import type { Message as ChatMessage, ToolInvocation as ChatToolInvocation } from './chat-types';
import { ChatInterface as ChatInterfaceComponent } from './interface/ChatInterface';
import type { ChatInterfaceHandle as ChatInterfaceHandleType, ChatInterfaceProperties } from './interface/types';
import { useUniversalChat as useUniversalChatImpl } from './provider/ChatContext';
import { LazyUniversalChatProvider as UniversalChatProviderComponent } from './provider/LazyUniversalChatProvider';
import type {
  UniversalChatContextPayload as UniversalChatContextPayloadType,
  UniversalChatContextValue as UniversalChatContextValueType,
} from './provider/types';

export function ChatInterface(properties: ChatInterfaceProperties) {
  return <ChatInterfaceComponent {...properties} />;
}

export function createDefaultWelcomeMessage() {
  return createDefaultWelcomeMessageImpl();
}

export function useUniversalChat() {
  return useUniversalChatImpl();
}

export function UniversalChatProvider(properties: ComponentProps<typeof UniversalChatProviderComponent>) {
  return <UniversalChatProviderComponent {...properties} />;
}

export type Message = ChatMessage;
export type ToolInvocation = ChatToolInvocation;
export type ChatInterfaceHandle = ChatInterfaceHandleType;
export type { ChatInterfaceProperties } from './interface/types';
export type UniversalChatContextPayload = UniversalChatContextPayloadType;
export type UniversalChatContextValue = UniversalChatContextValueType;
